<template>
    <div class="row order-info">
        <div class="col-12">
            <span
                class="text-underline cursor-pointer text-muted"
                style="position: absolute; top: -25px"
                @click="$router.back()"
                ><i class="fa fa-arrow-left" aria-hidden="true"></i> Go
                back</span
            >
            <h3>{{ locationInfo.name }}</h3>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Odoo Dealer ID:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.odoo_dealer_id }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Pricelist Name:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{
                                locationInfo.pricelist?.pricelist_name
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Address:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span
                                >{{ locationInfo.address }},
                                {{ locationInfo.city }},
                                {{ locationInfo.state }},
                                {{ locationInfo.zip_code }}</span
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>SOT Expiry Date:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.sot_expiry_date }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>FFL Expiry Date:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.ffl_expiry_date }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>SOT #:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.sot_number }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>FFL #:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.ffl_number }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>FFL EIN:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ locationInfo.ffl_ein }}</span>
                        </div>
                    </div>
                    <div v-if="$store.state.isSpeq">
                        <div class="row" style="color: white">
                            <div class="col-sm-3 col-md-2">
                                <label>SPEQ Status:</label>
                            </div>
                            <div class="col-sm-9 col-md-10">
                                <span
                                    v-if="locationInfo?.is_speq == 1"
                                    class="badge badge-success"
                                >
                                    Enrolled
                                </span>
                                <span
                                    class="badge badge-primary"
                                    v-else-if="
                                        locationInfo.speq_invite_status == 1
                                    "
                                >
                                    Invite Sent
                                </span>
                                <span
                                    class="badge badge-warning"
                                    v-else-if="
                                        locationInfo.speq_invite_status == 2
                                    "
                                >
                                    Pending
                                </span>
                                <span
                                    class="badge badge-success"
                                    v-else-if="
                                        locationInfo.speq_invite_status == 3
                                    "
                                >
                                    Accepted
                                </span>
                                <span
                                    class="badge badge-declined"
                                    v-else-if="
                                        locationInfo.speq_invite_status == 4
                                    "
                                >
                                    Declined
                                </span>
                                <template v-else>
                                  <span class="badge badge-secondary">
                                      N/A
                                  </span>
                                  <span class="ml-3 view-action" @click="useSendSpeqInivite(locationInfo)" v-if="user.speq_invite_access">
                                      INVITE?
                                  </span>
                                </template>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-2"></div>
                            <div
                                class="col-sm-9 col-md-10"
                                v-if="locationInfo?.is_speq == 0"
                            >
                                <span
                                    v-if="locationInfo?.speq_invite_status == 0 && user.speq_invite_status && user.speq_invite_access"
                                    class="add-button btn btn-action mt-1"
                                    @click="sendSpeqInvite"
                                    >Send SPEQ Invite</span
                                >
                                <span
                                    v-if="locationInfo?.speq_invite_status == 4 && user.speq_invite_access"
                                    class="add-button btn btn-action mt-1"
                                    @click="sendSpeqInvite"
                                    >Reset SPEQ Invite</span
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-2"></div>
                            <div
                                class="col-sm-9 col-md-10"
                                v-if="!locationInfo?.is_speq"
                            >
                                <span
                                    v-if="
                                        (locationInfo?.speq_invite_status == 3)"
                                    class="add-button btn btn-action mr-2"
                                    @click="adminAcceptSpeqInvite(3)"
                                    >Accept</span
                                >
                                <span
                                    v-if="
                                        (locationInfo?.speq_invite_status == 3)"
                                    class="add-button btn btn-action"
                                    @click="adminAcceptSpeqInvite(4)"
                                    >Reject</span
                                >
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>Sales Rep</h5>
                        <select
                            class="form-control"
                            v-model="salesRep"
                            @change="selectSalesRep"
                            required
                        >
                            <option value="null">Select Sales Rep</option>
                            <template
                                v-for="(item, idx) in allSalesReps"
                                :key="idx"
                            >
                                <option :value="item.id">
                                    {{ item.first_name }} {{ item.last_name }}
                                </option>
                            </template>
                        </select>
                    </div>
                </div>
                <div class="col-md-8"></div>
            </div>
            <br />
            <div class="d-flex align-items-center justify-content-between pb-2">
                <h3 class="mb-0">Users</h3>
                <div class="d-flex align-items-center">
                    <span
                        v-if="user.role.id == 1"
                        class="add-button btn btn-action mr-3"
                        @click="flagAllUsers(true)"
                    >
                        FLAG ALL USERS
                    </span>
                    <span
                        v-if="user.role.id == 1"
                        class="add-button btn btn-action"
                        @click="flagAllUsers(false)"
                    >
                        UNFLAG ALL USERS
                    </span>
                </div>
            </div>
            <table class="table table-responsive table-striped">
                <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th style="width: 10em">Speq Status</th>
                        <th style="width: 10em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in allUsersByLocation" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.address }}</td>
                        <td>{{ item.city }}</td>
                        <td>{{ item.state }}</td>
                        <td>{{ item.zip_code }}</td>
                        <td>{{ item.phone }}</td>
                        <td>{{ item.email }}</td>
                        <td>
                            <span
                                v-if="item.is_flagged"
                                class="badge badge-danger"
                                >FLAGGED</span
                            >
                        </td>
                        <td>
                            <span class="px-2 view-action">
                                <a
                                    :href="
                                        'https://portal.silencerco.com/impersonate/take/' +
                                        item.id +
                                        '/web'
                                    "
                                    class="view-action text-decoration-none"
                                    target="_self"
                                    @click="clearStorage"
                                >
                                    <i
                                        class="fa fa-sign-in"
                                        aria-hidden="true"
                                    ></i>
                                    IMPERSONATE
                                </a>
                                <!-- <a
                                    :href="
                                        'http://localhost:8000/impersonate/take/' +
                                        item.id +
                                        '/web'
                                    "
                                    class="view-action text-decoration-none"
                                    target="_self"
                                    @click="clearStorage"
                                >
                                    <i
                                        class="fa fa-sign-in"
                                        aria-hidden="true"
                                    ></i>
                                    IMPERSONATE
                                </a> -->
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useSendSpeqInivite } from "@/composables/speqInvite";

export default {
    props: ["id"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let locationInfo = computed(function () {
            return store.state.locationInfo;
        });
        let allUsersByLocation = computed(function () {
            return store.state.allUsersByLocation;
        });
        let allSalesReps = computed(function () {
            return store.getters["salesRep/allSalesReps"];
        });

        function assignSalesRepToLocation(request) {
            store.dispatch("salesRep/assignSalesRepToLocation", request);
        }
        function flagAllUsers(request) {
            store.dispatch("flagAllUsers", request);
        }

        onMounted(() => {
            store.dispatch("salesRep/getAllSalesReps");
        });

        return {
            store,
            user,
            locationInfo,
            allUsersByLocation,
            allSalesReps,
            assignSalesRepToLocation,
            flagAllUsers,
            useSendSpeqInivite
        };
    },
    data() {
        return {
            modalShowLocation: false,
            modalType: null,
            modalData: {},
            salesRep: "",
        };
    },
    mounted() {
        // this.getAllUsersByLocation(this.locationInfo.id);
        this.store.dispatch("getLocationById", this.id).then((resp) => {
            this.salesRep = this.locationInfo.sales_rep_id;
        });
    },
    methods: {
        openModalLocation(data, val) {
            let newData = {
                user_id: this.locationInfo.id,
            };
            this.modalData = newData;
            this.modalType = val;
            this.modalShowLocation = !this.modalShowLocation;
        },
        closeModalLocation() {
            this.modalShowLocation = !this.modalShowLocation;
        },
        selectSalesRep() {
            let requestData = {
                location_id: this.locationInfo.id,
                sales_rep_id: this.salesRep,
            };
            this.assignSalesRepToLocation(requestData);
        },
        clearStorage() {
            localStorage.setItem("orders", JSON.stringify([]));
        },
        sendSpeqInvite() {
            this.store.dispatch("sendSpeqInvite", this.locationInfo.id);
        },
        adminAcceptSpeqInvite(val) {
            this.store.dispatch("adminAcceptSpeqInvite", { id: this.locationInfo.id, speq_invite_status: val });
        },
        flagAllUsers(is_flag) {
            var request = {
                users: this.allUsersByLocation,
                is_flag: is_flag,
                location_id: this.locationInfo.id
            }
            this.flagAllUsers(request);

            window.emitter.emit("alertSuccess", {
                message: is_flag ? "All users has been flagged successfully!" : "All user has been unflagged successfully!",
            });
        }
    },
};
</script>
<style>
span.badge {
    font-size: 14px;
    color: white;
}
</style>
